'use client'

import { useTranslations } from '@dustin-web/microsite-components/src/hooks/use-translations'
import React from 'react'
import { CustomerNavigationFragment } from '@contentsite/src/graphql/generated/graphql-types'

type Props = {
  navigation: CustomerNavigationFragment
}

function CustomerNavigation({ navigation }: Props) {
  const { translate } = useTranslations()
  return (
    <section className="c-box u-px-0 u-pb-0 u-overflow-hidden">
      {navigation.parentCustomerName && (
        <div className="u-px-16">
          {navigation.parentCustomerLandingPageUrl && (
            <h2 className="h3">
              <a className="a-stripped" href={navigation.parentCustomerLandingPageUrl}>
                {translate('CustomerNavigation_YourParentsProductGroups', {
                  parentCustomerName: navigation.parentCustomerName,
                })}
              </a>
            </h2>
          )}
          <ul className="ul-stripped p-sm">
            {navigation.parentCustomerProductCategoryLinks.map(link => {
              return (
                <li key={link.displayName}>
                  <a className="a-stripped" href={link.url}>
                    {link.displayName}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      )}
      {navigation.productCategoryLinks.length > 0 && (
        <div className="u-px-16">
          <a className="a-stripped" href={navigation.landingPageUrl}>
            <h2 className="h3">{translate('CustomerNavigation_YourProductGroups')}</h2>
          </a>

          <ul className="ul-stripped p-sm">
            {navigation.productCategoryLinks.map(link => {
              return (
                <li key={link.displayName}>
                  <a className="a-stripped" href={link.url}>
                    {link.displayName}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      )}
      {navigation.documentsAndLinks.length > 0 && (
        <div className="u-px-16">
          <h2 className="h3">{translate('CustomerNavigation_DocumentsAndLinks')}</h2>
          <ul className="ul-stripped p-sm">
            {navigation.documentsAndLinks.map(link => {
              return (
                <li key={link.displayName}>
                  <a className="a-stripped" href={link.url}>
                    {link.displayName}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      )}
      {navigation.contacts.length > 0 && (
        <>
          <div className="u-px-16">
            <h2 className="h3">{translate('CustomerNavigation_YourContacts')}</h2>
          </div>
          <div className="container">
            <div className="row no-gutters">
              {navigation.contacts.map(contact => {
                return (
                  <article
                    key={contact.name}
                    className="u-py-12 u-bt u-bt-sm-none u-bt-lg u-border-light col-12 col-sm-6 col-lg-12">
                    <div className="row sm-gutters">
                      <div className="col-3 col-sm-4 col-md-3 col-lg-4 d-flex align-items-center">
                        <div
                          className="u-h-64 u-w-64"
                          style={{
                            borderRadius: '50%',
                            backgroundImage: `url(${contact.avatar?.url ?? ''})`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                          }}></div>
                      </div>
                      <section className="col-9 col-sm-8 col-md-9 col-lg-8 d-flex flex-column">
                        <h2 className="p-sm u-fw-bold u-mb-0">{contact.name}</h2>
                        <p className="u-mb-0 ">
                          <small>{contact.title}</small>
                        </p>
                        {contact.phone && (
                          <small>
                            <a className="d-block" href={`tel: ${contact.phone}`}>
                              {contact.phone}
                            </a>
                          </small>
                        )}
                        <small>
                          <a
                            href={`mailto:${contact.email ?? ''}`}
                            style={{ overflowWrap: 'break-word' }}>
                            {contact.email}
                          </a>
                        </small>
                      </section>
                    </div>
                  </article>
                )
              })}
            </div>
          </div>
        </>
      )}
      {navigation.logo && (
        <div className="u-px-16">
          <div className="u-py-12 u-bt u-bt-sm-none u-bt-lg">
            <img src={navigation.logo.url} style={{ maxHeight: '100px', maxWidth: '200px' }} />
          </div>
        </div>
      )}
    </section>
  )
}

export default CustomerNavigation
